import EmailValidator from "email-validator";
/*
let user = {
            firstName: firstName,
            lastName: lastName,
            emailAddress: emailAddress,
            username: username,
            password: password,
            roles: selectedRoles,
            isEnterprise: isEnterprise,
            sites: selectedSites
        }s
 */
export default function validate(values, isNew) {
  let errors = {};

  if (values.accountSecurity.type === "USERNAME" && !values.username) {
    errors.username = "missingUsername";
  } else if (
    values.accountSecurity.type === "EMAIL" &&
    !EmailValidator.validate(values.emailAddress)
  ) {
    errors.emailAddress = "invalidEmail";
  }

  if (values.accountSecurity.type === "USERNAME" && !values.password && isNew) {
    errors.password = "missingPassword";
  }

  if (!values.firstName) {
    errors.firstName = "missingFirstName";
  }

  if (!values.lastName) {
    errors.lastName = "missingLastName";
  }

  if (!values.defaultSite) {
    errors.defaultSite = "missingDefaultSite";
  }

  if (values.roles.length === 0) {
    errors.roles = "misssingRole";
  }

  if (!values.isEnterprise && values.sites.length === 0) {
    errors.sites = "missingSite";
  }

  return errors;
}
